/**
 * Vocabulaire de la qualification avancée — miroir de crm/qualification.py.
 * Le serveur fait foi (il refuse un verdict ou un motif inconnu) ; cette copie
 * sert aux filtres et aux pastilles sans un aller-retour.
 */
export const VERDICTS = [
  { value: "cible", label: "Cible" },
  { value: "hors_cible", label: "Hors cible" },
  { value: "a_verifier", label: "À vérifier" },
];

export const MOTIFS = [
  { value: "hors_perimetre_secteur", label: "Hors périmètre du secteur" },
  { value: "activite_differente", label: "Activité réelle différente du registre" },
  { value: "non_referencee_web", label: "Non référencée sur le web" },
  { value: "fermee_inactive", label: "Fermée ou inactive" },
  { value: "trop_petite", label: "Taille insuffisante" },
  { value: "deja_equipee", label: "Déjà équipée (concurrent)" },
  { value: "doublon", label: "Doublon d'une autre fiche" },
  { value: "autre", label: "Autre (voir note)" },
];

export const VERDICT_STYLE = {
  cible: "bg-emerald-50 text-emerald-700 border-emerald-200",
  hors_cible: "bg-rose-50 text-rose-700 border-rose-200",
  a_verifier: "bg-amber-50 text-amber-700 border-amber-200",
};

export const verdictLabel = (v) => VERDICTS.find((x) => x.value === v)?.label || v || "";
export const motifLabel = (m) => MOTIFS.find((x) => x.value === m)?.label || m;

/** La revérification est-elle échue ? (dates ISO jour, comparaison lexicale) */
export const recheckDue = (q, today = new Date()) =>
  Boolean(q?.recheck_at) && q.recheck_at <= today.toISOString().slice(0, 10);

/** Date ISO (jour) dans N jours — raccourcis « dans 1 mois / 3 mois ». */
export const inDays = (n, from = new Date()) => {
  const d = new Date(from); d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};
